import type { DepartmanDagilim, Personel } from '../types'
import { daysSince } from './tenure'

export function personelKpis(list: Personel[], now = new Date()) {
  const toplam = list.length
  const aktif = list.filter((p) => p.durum !== 'izinli').length
  return {
    toplam,
    departman: new Set(list.map((p) => p.departman)).size,
    aktif,
    aktifPct: toplam ? Math.round((aktif / toplam) * 100) : 0,
    izinli: list.filter((p) => p.durum === 'izinli').length,
    yeni: list.filter((p) => {
      const d = daysSince(p.ise_giris, now)
      return d >= 0 && d <= 90
    }).length,
  }
}

export function departmanDagilim(list: Personel[]): DepartmanDagilim[] {
  const counts = new Map<string, number>()
  for (const p of list) counts.set(p.departman, (counts.get(p.departman) ?? 0) + 1)
  return [...counts.entries()]
    .map(([name, count]) => ({ name, count, pct: list.length ? Math.round((count / list.length) * 100) : 0 }))
    .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name, 'tr'))
}

export function paginate<T>(rows: T[], page: number, size: number) {
  const pages = Math.max(1, Math.ceil(rows.length / size))
  const current = Math.min(Math.max(page, 1), pages)
  const start = (current - 1) * size
  return { pages, current, from: rows.length ? start + 1 : 0, to: Math.min(start + size, rows.length), items: rows.slice(start, start + size) }
}
